/* eslint-disable react-hooks/exhaustive-deps */
import { UsersAdmin } from 'src/core/models'
import { Button, Tooltip, Form } from 'antd'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { SendOutlined, StopOutlined } from '@ant-design/icons'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { resetRejectUserState } from 'src/features/admin/slice'
import { getUserAdminName, showNotification } from 'src/core/helpers'
import { CustomModal, CustomTitle, CustomTextArea } from 'src/components'
import { rejectUser, rejectUserSelector, usersAdminSelector } from 'src/features'

const UserAdminRejectButton: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { data: bigUsersList } = useAppSelector(usersAdminSelector)
  const { loading, currencUserId, success, error } = useAppSelector(rejectUserSelector)
  const isLoading = loading && currencUserId === user.id

  const tooltip = {
    NO_REJECTED: { label: t('Validate.RejectUser'), color: 'red' },
    REJECTED: { label: t('Validate.UserRejected'), color: 'black' },
    VALIDATED: { label: t('Validate.UserValidated'), color: '#2db7f5' },
  }[user.is_validate ? 'VALIDATED' : user.is_rejected ? 'REJECTED' : 'NO_REJECTED']


  const onFinish = ({ rejected_reason }: { rejected_reason: string }) => {
    dispatch(rejectUser(user.id, rejected_reason, bigUsersList))
  }

  /* Reject Features */
  useEffect(() => {
    if (success && currencUserId === user.id) {
      form.resetFields()
      setIsModalVisible(false)
      showNotification('success', t('Validate.UserRejectedSuccess'))
      dispatch(resetRejectUserState())
    }
  }, [success])

  useEffect(() => {
    if (error && currencUserId === user.id) {
      showNotification('warning', t('Validate.Error'))
      dispatch(resetRejectUserState())
    }
  }, [error])
  /* Reject Features Ends Here ...*/

  return <>
    <Tooltip title={tooltip.label} color={tooltip.color}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        icon={<StopOutlined />}
        disabled={user.is_validate || user.is_rejected}
        className={`radius-100 ml-2`}
        onClick={() => setIsModalVisible(true)}
      />
    </Tooltip>

    <CustomModal
      title={t('Validate.RejectTitle', { name: getUserAdminName(user) })}
      footer={null}
      open={isModalVisible}
      onCancel={() => {
        form.resetFields()
        setIsModalVisible(false)
      }}
    >
      <Form
        name='basic'
        onFinish={onFinish}
        autoComplete='off'
        form={form}
      >
        <CustomTitle label={t('Validate.ReasonLabel')} />
        <CustomTextArea
          name='rejected_reason'
          placeholder={t('Validate.ReasonPlaceholder')}
          rows={3}
          required
        />

        <Button
          type='primary'
          htmlType='submit'
          size='large'
          className='radius-100 mt-2'
          block
          loading={isLoading}
          icon={<SendOutlined />}
        >{isLoading ? t('Validate.ConfirmingRejection') :  t('Validate.ConfirmRejection')}
        </Button>
      </Form>
    </CustomModal>
  </>
}

export default UserAdminRejectButton
